(ns fablo-offers.common.utils
  (:require
   [clojure.string :as str]
   [cljs-bean.core :refer [->clj ->js] :as bean]))

;; from hicada.util, to use in cljs
(defn camel-case
  "Returns camel case version of the key, e.g. :http-equiv becomes :httpEquiv."
  [k]
  (if (or (keyword? k)
          (string? k)
          (symbol? k))
    (let [[first-word & words] (str/split (name k) #"-")]
      (if (or (empty? words)
              (= "aria" first-word)
              (= "data" first-word))
        k
        (-> (map str/capitalize words)
            (conj first-word)
            str/join
            keyword)))
    k))
;; from hicada.util, to use in cljs
(defn camel-case-keys
  "Recursively transforms all map keys into camel case."
  [m]
  (cond
    (map? m)
    (reduce-kv
     (fn [m k v]
       ;; extra step fox :_focus, :_hover in styles for Chakra -- fixme
       (if (and (map? v) (str/starts-with? (name k) "_"))
         (assoc m (camel-case k) (camel-case-keys v))
         (assoc m (camel-case k) v)))
     {} m)
    ;; React native accepts :style [{:foo-bar ..} other-styles] so camcase those keys:
    (vector? m)
    (mapv camel-case-keys m)
    :else
    m))

(defn js-camel-case-keys [m]
  (->js (camel-case-keys m)))

(defn snake-case
  "Returns snake_case version of the key, e.g. :http-equiv -> :http_equiv."
  [k]
  (if (or (keyword? k)
          (string? k)
          (symbol? k))
    (-> (name k)
        (str/replace "-" "_")
        keyword)
    k))

(defn snake-case-keys
  "Recursively transforms all map keys into snake_case."
  [m]
  (cond
    (map? m)
    (reduce-kv
     (fn [m k v]
       (assoc m (snake-case k) (snake-case-keys v)))
     {} m)

    (vector? m)
    (mapv snake-case-keys m)

    :else
    m))

(defn js-snake-case-keys [m]
  (->js (snake-case-keys m)))

(defn uuid-str []
  (str (random-uuid)))

(def days-pl
  {#time/day-of-week "MONDAY" "Poniedziałek"
   #time/day-of-week "TUESDAY" "Wtorek"
   #time/day-of-week "WEDNESDAY" "Środa"
   #time/day-of-week "THURSDAY" "Czwartek"
   #time/day-of-week "FRIDAY" "Piątek"
   #time/day-of-week "SATURDAY" "Sobota"
   #time/day-of-week "SUNDAY" "Niedziela"})

(def days-short-pl
  {#time/day-of-week "MONDAY" "PON"
   #time/day-of-week "TUESDAY" "WT"
   #time/day-of-week "WEDNESDAY" "ŚR"
   #time/day-of-week "THURSDAY" "CZW"
   #time/day-of-week "FRIDAY" "PT"
   #time/day-of-week "SATURDAY" "SOB"
   #time/day-of-week "SUNDAY" "NIEDZ"})

(def days-short-en
  {#time/day-of-week "MONDAY" "MON"
   #time/day-of-week "TUESDAY" "TUE"
   #time/day-of-week "WEDNESDAY" "WED"
   #time/day-of-week "THURSDAY" "THU"
   #time/day-of-week "FRIDAY" "FRI"
   #time/day-of-week "SATURDAY" "SAT"
   #time/day-of-week "SUNDAY" "SUN"})

(defn check-permission [required-permission roles]
  (if (or (empty? required-permission)
          (some #{:* :admin} roles))
    true
    (let [[p & ps] required-permission]
      (if-let [sub-roles (get roles p)]
        (check-permission ps sub-roles)
        false))))

